import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-linejoin": "round",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.5 7.5v-1h1v1h-1ZM8.5 13.5v-1h1v1h-1ZM8.5 19.5v-1h1v1h-1ZM14.5 7.5v-1h1v1h-1ZM14.5 13.5v-1h1v1h-1ZM14.5 19.5v-1h1v1h-1Z",
  fill: "currentColor"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }